// import ExcelJS from 'exceljs';
// import { saveAs } from 'file-saver';
// import ReactDOMServer from 'react-dom/server';

// const pagination = {
//   current: 1,
//   pageSize: 10
// };

// const exportToExcel = (data, columns) => {
//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet('Sheet1');

//   worksheet.addRow(columns.map(col => extractHeaderTitle(col)));

//   data.forEach((row, rowIndex) => {
//     worksheet.addRow(columns.map(col => {
//       if (col.dataIndex === 'id') {
//         const pageIndex = (pagination.current - 1) * pagination.pageSize;
//         return pageIndex + rowIndex + 1;
//       }

//       const cellValue = col.render ? col.render(row[col.dataIndex], row) : row[col.dataIndex];
//       return extractCellValue(cellValue);
//     }));
//   });

//   const headerRow = worksheet.getRow(1);
//   headerRow.eachCell({ includeEmpty: true }, (cell) => {
//     cell.fill = {
//       type: 'pattern',
//       pattern: 'solid',
//       fgColor: { argb: 'FFFF00' } 
//     };
//     cell.font = {
//       bold: true
//     };
//   });

//   columns.forEach((col, index) => {
//     worksheet.getColumn(index + 1).width = 20; 
//   });

//   workbook.xlsx.writeBuffer().then((buffer) => {
//     saveAs(new Blob([buffer]), 'table-data.xlsx');
//   });
// };

// const extractHeaderTitle = (col) => {
//   if (typeof col.title === 'string') {
//     return col.title;
//   } else if (col.title && col.title.props && col.title.props.children) {
//     return col.title.props.children;
//   }
//   return '';
// };

// const extractCellValue = (cellValue) => {
//   if (typeof cellValue === 'string' || typeof cellValue === 'number') {
//     return cellValue;
//   } else if (cellValue && typeof cellValue === 'object') {
//     return ReactDOMServer.renderToStaticMarkup(cellValue).replace(/<[^>]+>/g, ''); // Remove HTML tags
//   }
//   return ''; 
// };

// export default exportToExcel;


// import ExcelJS from 'exceljs';
// import { saveAs } from 'file-saver';
// import ReactDOMServer from 'react-dom/server';

// const pagination = {
//   current: 1,
//   pageSize: 10
// };

// const exportToExcel = (data, columns) => {
//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet('Sheet1');

//   worksheet.addRow(columns.map(col => extractHeaderTitle(col)));

//   data.forEach((row, rowIndex) => {
//     worksheet.addRow(columns.map(col => {
//       if (col.dataIndex === 'id') {
//         const pageIndex = (pagination.current - 1) * pagination.pageSize;
//         return pageIndex + rowIndex + 1;
//       }

//       const cellValue = col.render ? col.render(row[col.dataIndex], row) : row[col.dataIndex];
//       return extractCellValue(cellValue);
//     }));
//   });

//   const headerRow = worksheet.getRow(1);
//   headerRow.eachCell({ includeEmpty: true }, (cell) => {
//     cell.fill = {
//       type: 'pattern',
//       pattern: 'solid',
//       fgColor: { argb: 'FFFF00' } 
//     };
//     cell.font = {
//       bold: true
//     };
//   });

//   columns.forEach((col, index) => {
//     worksheet.getColumn(index + 1).width = 20; 
//   });

//   workbook.xlsx.writeBuffer().then((buffer) => {
//     saveAs(new Blob([buffer]), 'table-data.xlsx');
//   });
// };

// const extractHeaderTitle = (col) => {
//   if (typeof col.title === 'string') {
//     return col.title;
//   } else if (col.title && col.title.props && col.title.props.children) {
//     return col.title.props.children;
//   }
//   return '';
// };

// const decodeHtmlEntities = (str) => {
//   const tempElement = document.createElement('textarea');
//   tempElement.innerHTML = str;
//   return tempElement.value;
// };

// const extractCellValue = (cellValue) => {
//   if (typeof cellValue === 'string') {
//     return decodeHtmlEntities(cellValue); // Decode HTML entities
//   } else if (typeof cellValue === 'number') {
//     return cellValue;
//   } else if (cellValue && typeof cellValue === 'object') {
//     const staticMarkup = ReactDOMServer.renderToStaticMarkup(cellValue);
//     const plainText = staticMarkup.replace(/<[^>]+>/g, ''); // Remove HTML tags
//     return decodeHtmlEntities(plainText); // Decode any remaining entities
//   }
//   return '';
// };


// export default exportToExcel;



import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const exportToExcel = (data, columns) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Project Report');

  // Add headers
  const headerRow = worksheet.addRow(
    columns.map(col => {
      if (typeof col.title === 'string') return col.title;
      if (col.title?.props?.children) return col.title.props.children;
      return col.dataIndex;
    })
  );

  // Style headers
  headerRow.eachCell(cell => {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFD700' } // Gold color
    };
    cell.font = { bold: true };
    cell.border = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' }
    };
  });

  // Add data rows
  data.forEach((row, rowIndex) => {
    const dataRow = worksheet.addRow(
      columns.map(col => {
        // Handle serial number
        if (col.dataIndex === 'id') {
          return rowIndex + 1;
        }

        // Get raw value
        let value = row[col.dataIndex];
        
        // If value is null or undefined, return empty string
        if (value === null || value === undefined) {
          return '';
        }

        // If column has a render function, use it
        if (col.render) {
          try {
            const rendered = col.render(value, row, rowIndex);
            
            // If rendered is null/undefined, return empty string
            if (rendered === null || rendered === undefined) {
              return '';
            }
            
            // Handle Tooltip content
            if (rendered?.props?.title) {
              return rendered.props.title;
            }
            
            // Handle React elements
            if (rendered?.props) {
              // If it's a React element with children, return the children
              if (rendered.props.children) {
                // For simple text children
                if (typeof rendered.props.children === 'string') {
                  return rendered.props.children;
                }
                // For more complex children, return empty string
                return '';
              }
              // For other React elements without children, return empty string
              return '';
            }
            
            // For non-React values, return as-is
            return rendered;
          } catch (e) {
            console.error('Error rendering column:', col.dataIndex, e);
            return '';
          }
        }

        // Handle nested objects in raw data
        if (typeof value === 'object' && value !== null) {
          // Skip React-like objects
          if (value.$$typeof) return '';
          
          return value?.name || value?.description || '';
        }

        return value;
      })
    );

    // Add borders to data cells
    dataRow.eachCell(cell => {
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });
  });

  // Auto-fit columns
  columns.forEach((_, i) => {
    worksheet.getColumn(i + 1).width = 25;
  });

  // Generate and download
  workbook.xlsx.writeBuffer().then(buffer => {
    saveAs(
      new Blob([buffer], { type: 'application/octet-stream' }),
      `Project-Report-${new Date().toISOString().split('T')[0]}.xlsx`
    );
  });
};

export default exportToExcel;